import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AppDataProvider } from "./store/AppDataContext";


function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AppDataProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
        </BrowserRouter>
      </AppDataProvider>
    </I18nextProvider>
  );
}

export default App;
